export default "__VITE_ASSET__6VuK1$ed__"